import { Pair, mk_pair } from "widgets-for-react";
import { ImageSize } from "../../cms/blocks/types.gen";
import { WordPress } from "../../wordpress/wordpress_api";

export type ExtraImages = 'media' | 'teaser' | 'grid' | 'quote' | 'attention' | 'stack' | 'featured' | 'step_image' | 'carousel'| 'highlightFirst' | 'highlightSecond' | 'highlightThird'


export let get_default_data_src : () => ImageSize<ExtraImages> = () => "full"
export let get_default_data_srcset : () => Pair<ImageSize<ExtraImages>, string>[] = () => 
  [
    //example: mk_pair('media_w432' as ExtraImages, "424w"),
  ]

export function getImageSize<t>(media: WordPress.Image, size: string | ImageSize<t>) : string {
  let image_size: string = size.toString()
  return media && media.media_details && media.media_details.sizes && media.media_details.sizes[image_size] && media.media_details.sizes[image_size].source_url ? 
    media.media_details.sizes[image_size].source_url 
  : media.source_url;
}

export function getImageAttribute<t>(media: WordPress.Image, size: string | ImageSize<t>, attr: string) : string {
  let image_size: string = size.toString()
  if (media && media.media_details && media.media_details.sizes && media.media_details.sizes) {
    return media.media_details.sizes[image_size] && media.media_details.sizes[image_size][attr] ? 
      media.media_details.sizes[image_size][attr] 
    : media.media_details.sizes['full'] && media.media_details.sizes['full'][attr] ? 
      media.media_details.sizes['full'][attr] 
    : ''
  }

  return ''
}

export const placeholderImage: (alt) => WordPress.Image = (alt) => {
  return {
    alt_text: alt,
    post: 9999,
    source_url: '',
    id: 1337,
    date: '',
    date_gmt: '',
    guid: {
      rendered: ''
    },
    modified: '',
    modified_gmt: '',
    slug: 'placeholder',
    status: 'inherit',
    type: 'attachment',
    link: '',
    title: {
      rendered: '',
    },
    author: 1337,
    comment_status: 'open',
    ping_status: 'open',
    template: '',
    meta: [],
    acf: [],
    description: {
      rendered: ''
    },
    caption: {
      rendered: ''
    },
    media_type: 'image',
    mime_type: 'image/jpeg',
    media_details: {
      file: '',
      height: 0,
      width: 0,
      image_meta: {
        aperture: '',
        credit: '',
        camera: '',
        caption: '',
        created_timestamp: '',
        copyright: '',
        focal_length: '',
        iso: '',
        shutter_speed: '',
        title: '',
        orientation: 'landscape',
        keywords: []
      },
      sizes: {
        full: {
          mime_type: 'image/jpeg',
          file: '',
          height: 1600, 
          width: 900,
          source_url: 'http://placehold.it/1600x900'
        },
        large: {
          mime_type: 'image/jpeg',
          file: '',
          height: 1600, 
          width: 900,
          source_url: 'http://placehold.it/1600x900'
        },
        medium_large: {
          mime_type: 'image/jpeg',
          file: '',
          height: 1600, 
          width: 900,
          source_url: 'http://placehold.it/1600x900'
        },
        medium: {
          mime_type: 'image/jpeg',
          file: '',
          height: 1600, 
          width: 900,
          source_url: 'http://placehold.it/1600x900'
        },
        media: {
          mime_type: 'image/jpeg',
          file: '',
          height: 1600, 
          width: 900,
          source_url: 'http://placehold.it/1600x900'
        },
        teaser: {
          mime_type: 'image/jpeg',
          file: '',
          height: 500, 
          width: 400,
          source_url: 'http://placehold.it/500x400'
        },
        grid: {
          mime_type: 'image/jpeg',
          file: '',
          height: 440, 
          width: 250,
          source_url: 'http://placehold.it/440x250'
        },
        quote: {
          mime_type: 'image/jpeg',
          file: '',
          height: 560, 
          width: 660,
          source_url: 'http://placehold.it/560x660'
        },
        attention: {
          mime_type: 'image/jpeg',
          file: '',
          height: 1920, 
          width: 800,
          source_url: 'http://placehold.it/1920x800'
        },
        stack: {
          mime_type: 'image/jpeg',
          file: '',
          height: 560, 
          width: 600,
          source_url: 'http://placehold.it/560x600'
        },
        square: {
          mime_type: 'image/jpeg',
          file: '',
          height: 800, 
          width: 800,
          source_url: 'http://placehold.it/800x800'
        },
        carousel: {
          mime_type: 'image/jpeg',
          file: '',
          height: 360, 
          width: 334,
          source_url: 'http://placehold.it/360x334'
        },
        highlightFirst: {
          mime_type: 'image/jpeg',
          file: '',
          height: 1110, 
          width: 1110,
          source_url: 'http://placehold.it/1110x1110'
        },
        highlightSecond: {
          mime_type: 'image/jpeg',
          file: '',
          height: 1840, 
          width: 1746,
          source_url: 'http://placehold.it/1840x1746'
        },
        highlightThird: {
          mime_type: 'image/jpeg',
          file: '',
          height: 1110, 
          width: 778,
          source_url: 'http://placehold.it/1110x778'
        }
      }
    }
  }
}